import { GridStore } from 'Core/Controls/Grid/Stores/GridStore';
import * as _ from 'underscore';
import * as moment from 'moment';
import * as ko from 'knockout'
import * as $ from "jquery";

import {LifeStatuses} from "Core/Enums/LifeStatuses";
import {RenderModes, LIFE_STATUS_NAMES, CONTROL_TYPES} from "Core/Constant";
import {DATE_FORMATS} from 'Core/Constants/DateTimeFormats';

import {IProgressBarParams} from "Core/Components/ProgressBar/IProgressBarParams";

import {ActionSubjectRecordModel} from "Core/ScreenManager/Models/ActionSubjectRecordModel";
import {LifeStatusInfo} from "Core/ScreenManager/Models/LifeStatusInfo";
import {RecordSpecsModel} from "Core/ScreenManager/Models/RecordSpecsModel";
import {LifeStatusViewModel} from "Core/Components/ProgressBar/Models/View/LifeStatusViewModel";
import {FlowFolderStore} from "Core/Components/ProgressBar/Stores/FlowFolderStore";
import {HelpBook} from 'HelpBook/HelpBook';

import ViewTemplate from 'Core/Components/ProgressBar/Templates/View.html';
import EditTemplate from 'Core/Components/ProgressBar/Templates/Edit.html';
import {NOTIFICATIONS, LABELS, CONFIRMATIONS} from "Core/Components/Translation/Locales";
import {FormatConverter} from "FormatEditor/FormatConverter";
import { ActionCheckList } from "../ActionCheckList/ActionCheckList";
import { LifeStatusesGeneralModel } from "Core/Controls/ButtonFollowUp/Models/LifeStatusesGeneralModel";
import { FollowUpRecordModel } from "Core/Controls/ButtonFollowUp/Models/FollowUpRecordModel";
import { FollowUpParentRecordModel } from "Core/Controls/ButtonFollowUp/Models/FollowUpParentRecordModel ";
import { FollowUpLifeStatuses } from "Core/Controls/ButtonFollowUp/FollowUpLifeStatuses";
import { LifeStatusesModel } from 'Core/Controls/ButtonFollowUp/Models/LifeStatusesModel';
import { FollowUpOptionModel } from "Core/Controls/ButtonFollowUp/Models/FollowUpOptionModel";
import { BaseScreen } from "Core/Screens/BaseScreen";
import { SubjectActionModel } from "Core/Controls/ButtonFollowUp/Models/SubjectActionModel";


import {Notifier} from "../../Common/Notifier";
import {FlowFolderModel} from "./Models/Response/FlowFolderModel";
import {ScreenParamsModel} from "Core/Controls/ButtonFollowUp/Models/ScreenParamsModel";
import { BlockUI } from 'Core/Common/BlockUi';
import { ProgressBarInfoModel } from './Models/Response/ProgressBarInfoModel';
import { LifeStatusSimpleModel } from 'Core/Controls/ButtonFollowUp/Models/LifestatusSimpleModel';
import { ActionDropdown } from './ActionDropdown/ActionDropdown';
import { SubflowMonitor } from './SubflowMonitor/SubflowMonitor';
import { SubflowMonitorStore } from './Stores/SubflowMonitorStore';
import { SubflowMonitorModel } from './Models/Response/SubflowMonitorModel';
import type { ProcessCard } from 'Core/Screens/ProcessCard/ProcessCard';
import {TableStore} from "Core/Common/Stores/TableStore";
import {EntityTypesStore} from "Core/Screens/TypeScreen/Stores/EntityTypesStore";
import {EditScreen} from "Core/Screens/EditScreen/EditScreen";
import {GlobalManager, GLOBALS} from "Core/GlobalManager/GlobalManager";
import {LinkList} from "Core/Controls/LinkList/LinkList";
import {
    ConfirmationDialog,
    EVENTS as CONFIRMATION_DIALOG_EVENTS,
    Types as ConfirmationTypes
} from "Core/Components/Dialogs/ConfirmationDialog/ConfirmationDialog";

interface IProgressBarActiveParams {
    RenderMode: RenderModes;
    ActiveLifeStatus: LifeStatusInfo;
}

export class ProgressBar {
    private _entityId: number;
	private _recordId: number;
	private _typeId: number;
    private _actionSubject: ActionSubjectRecordModel;
    private _recordSpecs: RecordSpecsModel;
    private _renderMode: RenderModes;
	private _lifeStatus: LifeStatusViewModel;
	private _help: HelpBook;
    private _title: KnockoutObservable<string>;
    private _tableTypeName: KnockoutObservable<string>;
    private _checkList: ActionCheckList;
    private _labels = LABELS;
    private _flowFolder: boolean;
    private _isEditScreen: boolean;

    private _followUpRecord: FollowUpRecordModel;
    private _followUpLifeStatuses: FollowUpLifeStatuses;
    private _lifeStatuses: LifeStatusesModel;
    private _screen: BaseScreen;
    private _el: HTMLElement;
    private _El: HTMLElement;
    private _data: ProgressBarInfoModel;
    private _subflowMonitors: Array<SubflowMonitorModel>;
    private _hasOpenSubflows: KnockoutObservable<boolean>;

    constructor(params: IProgressBarParams) {
        this._title = ko.observable(null);
        this._screen = params.Screen;
        const tableTypeName = this._screen.GetTableTypeNameTranslation()
            ? this._screen.GetTableTypeNameTranslation()
            : this._screen.GetTableTypeName();

        if (tableTypeName && tableTypeName !== '-') {
            this._tableTypeName = ko.observable(tableTypeName +', ');
        }

        this._recordSpecs = params.RecordSpecs;

        this._entityId = params.EntityId;
		this._recordId = params.RecordId;
		this._typeId = params.TypeId;
        this._actionSubject = this._screen.GetActionSubjectRecord();

        this._flowFolder = params.Screen.GetTableTypeFlowFolder();
        this._isEditScreen = params.Screen.IsEditScreen;

        const activeParams = this.GetActiveParams(params);

        this._renderMode = activeParams.RenderMode;

        this._lifeStatus = this.MapToViewModel(activeParams.ActiveLifeStatus);
        this._lifeStatus.Enabled.subscribe(() => this.ModifyLifeStatus());

        this._lifeStatuses = null;
        this._followUpLifeStatuses = null;

        this._subflowMonitors = [];
        this._hasOpenSubflows = ko.observable(false);
        this.LoadSubflowMonitor();

		this._help = HelpBook.Instance;
    }

    private LoadSubflowMonitor() {
        const lifeStatusId = this._recordSpecs && this._recordSpecs.LifeStatusInfo && this._recordSpecs.LifeStatusInfo.Id;
        if (this._isEditScreen || !this._recordId || !lifeStatusId) {
            return;
        }

        SubflowMonitorStore.GetUnfinishedSubflowRecords({
            EntityId: this._entityId,
            RecordId: this._recordId,
            LifeStatusId: lifeStatusId
        })
            .then(monitors => {
                this._subflowMonitors = monitors;
                // the icon reflects the subflow status itself: while the record is
                // parked on a subflow node it is held, whatever the gates say
                this._hasOpenSubflows(monitors.length > 0);
            })
            .fail(() => {});
    }

    ShowUnfinishedSubflows(data?: any, event?: any) {
        if (!this._hasOpenSubflows()) {
            return;
        }
        const lifeStatusId = this._recordSpecs && this._recordSpecs.LifeStatusInfo && this._recordSpecs.LifeStatusInfo.Id;
        const monitor = new SubflowMonitor(this._subflowMonitors, {
            EntityId: this._entityId,
            RecordId: this._recordId,
            LifeStatusId: lifeStatusId
        });
        monitor.Show(event && event.currentTarget ? event.currentTarget : this._el);
    }

    GetTemplate() {
        switch (this._renderMode) {
            case RenderModes.View:
                return this.GetViewTemplate();
            case RenderModes.Edit:
                return this.GetEditTemplate();
            default:
                throw new Error(`Render mode ${RenderModes[this._renderMode]} is not supported`);
        }
    }

    GetLifeStatus() {
        const lifeStatus = new LifeStatusInfo();

        lifeStatus.Name = this._lifeStatus.Enabled() ? LifeStatuses.Enabled.Name : LifeStatuses.Disabled.Name;
        lifeStatus.LastStatusDate = new Date(this._lifeStatus.Date());
        lifeStatus.Modified = this._lifeStatus.Modified;
        lifeStatus.IsCustomStatuses = this.CheckIfStatusIsCustom(lifeStatus.Name);

        return lifeStatus;
    }

    CheckIfStatusIsCustom(name: string): boolean {
        return name !== LIFE_STATUS_NAMES.DISABLED && name !== LIFE_STATUS_NAMES.ENABLED;
    }

	RequestCheckList(data?: any, event?: any) {
		if (this._help.IsHelpButtonPressed()) {
			this._help.ShowTypeHelp(this);
			return;
        }

        // parked on a subflow node the record is advanced by its children, never
        // by hand: clicking the bar shows the monitor instead of the checklist
        if (this._hasOpenSubflows()) {
            this.ShowUnfinishedSubflows(data, event);
            return;
        }

        if (this._screen.GetDataModel().RecordSpecs.IsDisabled) {
            new Notifier().Warning(this._labels.RECORD_IS_DISABLED);
            return;
        }

        if (!this._recordId){
            return;
        }

        BlockUI.Block({Target: this._El});
        FlowFolderStore.GetProgressBarInfo({ EntityId: this._entityId, RecordId: this._recordId })
            .always(()=> BlockUI.Unblock(this._El))
            .then(result => {
                this._data = result;
                this.DoProgressBarProcess();
            })
            .fail((err) => new Notifier().Failed(err.message));
    }

    DoProgressBarProcess(){
        let lifeStatuses = _.filter(this._data.NextLifeStatuses.Child.LifeStatuses, (lifeStatus)=>lifeStatus.ProcessCardId != 0);
        let showStatusSelector = this._data.NextLifeStatuses.Child.LifeStatuses.length != lifeStatuses.length;
        if(lifeStatuses.length > 0){
            this.ShowActionDropdown({ lifeStatuses, showStatusSelector });
            return;
        }
        if (this._data.NextLifeStatuses.SubjectAction) {
            if (this._screen.IsConsultScreen) {
                this.ProcessingStatuses(this._data.NextLifeStatuses, this._data.FlowFolder);
            } else {
                this.ProcessingCheckList(this._data.NextLifeStatuses);
            }

        } else {
            this.CreateAction();
        }
       
    }

    ShowStatusSelector(){
        this._data.NextLifeStatuses.Child.LifeStatuses = _.filter(this._data.NextLifeStatuses.Child.LifeStatuses, (lifeStatus)=>lifeStatus.ProcessCardId == 0);

        if (this._data.NextLifeStatuses.SubjectAction) {
            if (this._screen.IsConsultScreen) {
                this.ProcessingStatuses(this._data.NextLifeStatuses, this._data.FlowFolder);
            } else {
                this.ProcessingCheckList(this._data.NextLifeStatuses);
            }

        } else {
            this.CreateAction();
        }
    }
    
    AddLinkAction(){
        BlockUI.Block({Target: this._El});
        const globalManager = GlobalManager.Instance;
        const actionGlobal = globalManager.GetGlobal(GLOBALS.ACTION_TABLE);
        TableStore.Get({TableName: actionGlobal})
            .fail((err) => new Notifier().Failed(err.message))
            .then((table: any) => {
                EntityTypesStore.GetTypes({
                    EntityId: table.Id,
                    ParentTypeId: 0,
                    WithRoot: true,
                    OnlyEnabled: true
                })
                    .always(() => BlockUI.Unblock(this._El))
                    .then(tableTypesModel => {
                        const actionType = _.find(tableTypesModel.TableTypes, (type) => {
                            return type.Name === 'Action';
                        });

                        const tableEntityId = table.Id;
                        const actionTypeId = actionType.Id;
                        const kindId = 0;
                        const exampleRecordId = 0;

                        const actionSubjectRecord = table.Name === actionGlobal
                            ? new ActionSubjectRecordModel(this._entityId, this._recordId)
                            : null;

                        this.GetEditScreen(tableEntityId, actionTypeId, kindId, exampleRecordId, actionSubjectRecord);
                    })
            })
    }

    CreateAction(){

        if(!this._data.HasActionLink){
             const globalManager = GlobalManager.Instance;
            const actionGlobal = globalManager.GetGlobal(GLOBALS.ACTION_TABLE);
            new Notifier().Failed(NOTIFICATIONS.LINK_TABLE_NOT_FOUND.replace('{ActionTable}', actionGlobal));
            return;
        }

        const confirmationDialog = new ConfirmationDialog({
            Text: CONFIRMATIONS.NO_ACTIVE_ACTIONS_CREATE_NEW,
            Type: ConfirmationTypes.Question,
            TextConfirm: LABELS.OK,
            TextDecline: LABELS.CANCEL
        })
        confirmationDialog.On(CONFIRMATION_DIALOG_EVENTS.CONFIRM_SELECTED, this, () => {
            this.AddLinkAction();
        })
        confirmationDialog.Show();
    }

    async GetEditScreen(entityId: number, tableTypeId: number, kindId: number, exampleRecordId: number, actionSubjectRecord: ActionSubjectRecordModel ){
        const screenManager = (await import('Core/ScreenManager/ScreenManager')).ScreenManager;
        BlockUI.Block();
        screenManager.GetEditScreen({
            EntityId: entityId,
            TableTypeId: tableTypeId,
            KindId: kindId,
            RecordId: exampleRecordId,
            LoadAsExample: exampleRecordId > 0,
            SubjectLifestatusId: this._recordSpecs.LifeStatusInfo.Id,
            ActionSubjectRecord: actionSubjectRecord
        })
            .always(() => {
                BlockUI.Unblock();
            })
            .fail(error => {
                const notifier = new Notifier($(this._el));

                notifier.Warning(error.message);
            })
            .then((screen) => {
                const editScreen = screen as EditScreen;
                editScreen.IsDataFromExample = exampleRecordId > 0;

                if (screen.GetControl(CONTROL_TYPES.LinkList)) {
                    screen.On('LINK_LIST_DATA_LOADED',
                        this,
                        eventArgs => {
                            let linkListControl = eventArgs.data.Control as LinkList;
                            let model = _.find(linkListControl.DataModel().Entities(), entity => entity.EntityId === this._entityId);
                            if (model) {
                                linkListControl.AfterSelectRecord([this._recordId], model);
                                editScreen.SaveImmediately = true;
                            } else {
                                editScreen.SaveImmediately = false;
                            }
                        });
                } else {
                    editScreen.SaveImmediately = false;
                }

                screen.On('RECORD_SAVED',
                    this,
                    () => {
                        this._screen.Refresh();
                    });
                
                screen.ShowInModal();
            })
    }

    async ShowProcessCard(status: LifeStatusSimpleModel){
        BlockUI.Block();
        const screenManager = (await import('Core/ScreenManager/ScreenManager')).ScreenManager;
        screenManager.GetScreenById({ ScreenId: status.ProcessCardId })
        .always(()=>BlockUI.Unblock())
        .then((screen: ProcessCard)=>{
            screen.On('FINISH_PROCESS', this, ()=>this.SwitchToNextStatus(status.Id));
            screen.LoadStepControlData({ recordId: this._recordId });
            screen.ShowInModal();            
        });
    }

    SwitchToNextStatus(nextStatusId: number){
        GridStore.SwitchToNextStatus({ EntityId: this._entityId, RecordId: this._recordId, NextStatusId: nextStatusId }).then(()=>this._screen.Refresh());
    }

    ShowActionDropdown({ lifeStatuses, showStatusSelector }: { lifeStatuses: Array<LifeStatusSimpleModel>, showStatusSelector: boolean }){
        let actionDropdown = new ActionDropdown(lifeStatuses, showStatusSelector);
        actionDropdown.On('SHOW_STATUS_SELECTOR', this, ()=>this.ShowStatusSelector());
        actionDropdown.On('RECORD_SELECTED', this, (evtArgs)=>this.ShowProcessCard(evtArgs.data.status));
        actionDropdown.Show(this._el);        
    }

    ProcessingCheckList(model: LifeStatusesGeneralModel) {
        if (!this._checkList) {
            this._checkList = new ActionCheckList({
                EntityId: this._entityId,
                RecordId: this._recordId,
                FollowUpMode: false,
                CurrentLifestatus: model.Child.CurrentLifeStatus
            });
        }

        this._checkList.ProvideData(model.Child && model.Child.CheckLists);
        if (this._checkList.HasAnyCheckedStatuses()) {
            this._checkList.Show();
        } else {
            new Notifier().Warning(this._labels.THERE_ARE_NO_NEXT_STATUSES_WITH_CHECK_LIST);
        }
    }

    ProcessingStatuses(result: LifeStatusesGeneralModel, flowFolderModel?: FlowFolderModel) {
        if (result == null || !result.Child) {
            return;
        }

        if (!this._followUpRecord) {
            this._followUpRecord = new FollowUpRecordModel();
        }

        if (!this._followUpLifeStatuses){
            this._followUpLifeStatuses = new FollowUpLifeStatuses();
        }
        const screenParams: ScreenParamsModel = { EntityId: this._entityId, RecordId: this._recordId };

        if (result.Child.CurrentLifeStatus === null && result.Child.LifeStatuses.length === 1) {
            const firstStatus = result.Child.LifeStatuses[0];
            this._followUpRecord.LifeStatusId = firstStatus.Id;
            this._followUpRecord.LifeStatusSort = firstStatus.Sort;
            this._followUpRecord.LifeStatusName = firstStatus.Name;
            this._followUpRecord.LifeStatusNoActionNode = firstStatus.NoActionNode;
            this.FireFollowUp(result.SubjectAction);
            return;
        }

        this._followUpRecord.CurrentLifeStatus = result.Child.CurrentLifeStatus;

        this._lifeStatuses = result.Child;
        const showCheckLists = _.any(this._lifeStatuses.CheckLists, checkList => checkList.CheckItems.length > 0)
            && (!result.IsManyActions || result.Child.CurrentLifeStatus.MultipleActions);

        if (!result.IsManyActions && showCheckLists) {
            this.ShowCheckLists(result, this._flowFolder && !this._isEditScreen, screenParams, flowFolderModel);
            return;
        }

        let infiniteLoop = result.Parent && result.Child && (result.Parent.ActionSubjectRecord.RecordId === result.Child.ActionSubjectRecord.RecordId);
        if(!result.IsManyActions && infiniteLoop && showCheckLists) {
            this.ShowCheckLists(result, this._flowFolder && !this._isEditScreen, screenParams, flowFolderModel);
            return;
        }

        if (result.IsManyActions && !result.Child.CurrentLifeStatus.MultipleActions) {
            result.Child.LifeStatuses = [result.Child.CurrentLifeStatus];
            this._followUpLifeStatuses.Caption = LABELS.EXIST_ACTIVE_ACTIONS;
        } else if (showCheckLists && result.Child.CurrentLifeStatus.MultipleActions) {
            this.ShowCheckLists(result, this._flowFolder && !this._isEditScreen, screenParams, flowFolderModel);
            return;
        }

        const followUpOption = new FollowUpOptionModel();
        followUpOption.LifeStatuses = result.Child;

        let followUpParentOption: FollowUpOptionModel;
        if (result.Parent) {
            followUpParentOption = new FollowUpOptionModel();
            followUpParentOption.LifeStatuses = result.Parent;
        }

        if (this._lifeStatuses.LifeStatuses.length === 0) {
            new Notifier().Warning(NOTIFICATIONS.NEXT_STATUS_NOT_AVAILABLE);
        }


        this._followUpLifeStatuses.Init(followUpOption, followUpParentOption, screenParams);
        this._followUpLifeStatuses.InitFlowFolder(this._flowFolder && !this._isEditScreen, this._entityId, flowFolderModel, result);

        this.ShowStandardFollowUp(result);
    }

    private ShowCheckLists(result: LifeStatusesGeneralModel, isFlowFolder: boolean, screenParams, flowFolderModel: FlowFolderModel) {
        const actionSubject = result.Child.ActionSubjectRecord;
        const checkLists = result.Child.CheckLists;

        if (!this._checkList) {
            this._checkList = new ActionCheckList({
                EntityId: actionSubject.EntityId,
                RecordId: actionSubject.RecordId,
                FollowUpMode: true,
                CurrentLifestatus: result.Child.CurrentLifeStatus
            });
            this._checkList.On('LIFESTATUS_CHOOSEN',
                this,
                eventArgs => {
                    this._followUpRecord.LifeStatusId = eventArgs.data.LifeStatus.Id || eventArgs.data.LifeStatus.LifeStatusId;
                    this._followUpRecord.LifeStatusSort = eventArgs.data.LifeStatus.Sort || eventArgs.data.LifeStatus.LifeStatusSort;
                    this._followUpRecord.LifeStatusName = eventArgs.data.LifeStatus.Name || eventArgs.data.LifeStatus.LifeStatusName;
                    this._followUpRecord.LifeStatusNoActionNode = eventArgs.data.LifeStatus.NoActionNode || eventArgs.data.LifeStatus.LifeStatusNoActionNode;
                    this._followUpRecord.ConfirmationPassword = eventArgs.data.Password;
                    this._followUpRecord.RetireChildren = eventArgs.data.RetireChildren;
                    this.FireFollowUp(result.SubjectAction);
                });
        }

        this._checkList.ProvideData(checkLists);
        this._checkList.InitFlowFolder(isFlowFolder, screenParams.EntityId, flowFolderModel, result);
        this._checkList.Show();
    }

    private ShowStandardFollowUp(result: LifeStatusesGeneralModel) {
        this._followUpLifeStatuses.On('LIFESTATUS_CHOOSEN',
            this,
            eventArgs => {
                this._followUpRecord.LifeStatusId = eventArgs.data.LifeStatus.Id || eventArgs.data.LifeStatus.LifeStatusId;
                this._followUpRecord.LifeStatusSort = eventArgs.data.LifeStatus.Sort || eventArgs.data.LifeStatus.LifeStatusSort;
                this._followUpRecord.LifeStatusName = eventArgs.data.LifeStatus.Name || eventArgs.data.LifeStatus.LifeStatusName;
                this._followUpRecord.LifeStatusNoActionNode = eventArgs.data.LifeStatus.NoActionNode || eventArgs.data.LifeStatus.LifeStatusNoActionNode;
                this._followUpRecord.ConfirmationPassword = eventArgs.data.Password;
                this._followUpRecord.RetireChildren = eventArgs.data.RetireChildren;
                this.FireFollowUp(result.SubjectAction);
            });

        this._followUpLifeStatuses.On('PARENT_LIFESTATUS_CHOOSEN',
            this,
            eventArgs => {
                const parentRecord = new FollowUpParentRecordModel();
                parentRecord.ParentActionSubject = result.Parent.ActionSubjectRecord;
                parentRecord.CurrentLifeStatus = result.Parent.CurrentLifeStatus;
                parentRecord.LifeStatusId = eventArgs.data.LifeStatus.Id || eventArgs.data.LifeStatus.LifeStatusId;
                parentRecord.LifeStatusSort = eventArgs.data.LifeStatus.Sort || eventArgs.data.LifeStatus.LifeStatusSort;
                parentRecord.LifeStatusName = eventArgs.data.LifeStatus.Name || eventArgs.data.LifeStatus.LifeStatusName;
                parentRecord.LifeStatusNoActionNode = eventArgs.data.LifeStatus.NoActionNode || eventArgs.data.LifeStatus.LifeStatusNoActionNode;
                parentRecord.ConfirmationPassword = eventArgs.data.Password;
                this._followUpRecord.FollowUpParentRecord = parentRecord;
                this.FireFollowUp(result.SubjectAction);
            });

        this._followUpLifeStatuses.On('CHILD_LIFESTATUS_CHOOSEN',
            this,
            eventArgs => {
                this._followUpRecord.LifeStatusId = eventArgs.data.LifeStatus.Id || eventArgs.data.LifeStatus.LifeStatusId;
                this._followUpRecord.LifeStatusSort = eventArgs.data.LifeStatus.Sort || eventArgs.data.LifeStatus.LifeStatusSort;
                this._followUpRecord.LifeStatusName = eventArgs.data.LifeStatus.Name || eventArgs.data.LifeStatus.LifeStatusName;
                this._followUpRecord.LifeStatusNoActionNode = eventArgs.data.LifeStatus.NoActionNode || eventArgs.data.LifeStatus.LifeStatusNoActionNode;
                this._followUpRecord.ConfirmationPassword = eventArgs.data.Password;
            });

        this._followUpLifeStatuses.On('DONE',
            this,
            () => {
                this._screen.Trigger('FOLLOWUP_DONE');
            });

        this._followUpLifeStatuses.ShowInModal();
    }

    CloseActionCheckList() {
        if (this._checkList) {
            this._checkList.Close();
        }
    }

    private GetActiveParams(params: IProgressBarParams) {
        switch (params.RenderMode) {
            case RenderModes.View:
                return this.GetViewActiveParams(params.RecordSpecs);
            case RenderModes.Edit:
                return this.GetEditActiveParams(params.MigratedRequired, params.RecordSpecs);
            default:
                throw new Error(`Render mode ${RenderModes[this._renderMode]} is not supported`);
        }
    }

    private GetViewActiveParams(recordSpecs: RecordSpecsModel): IProgressBarActiveParams {
        let activeRenderMode = RenderModes.View;
        let activeLifeStatus = recordSpecs.LifeStatusInfo;

        return {
            RenderMode: activeRenderMode,
            ActiveLifeStatus: activeLifeStatus
        };
    }

    private GetEditActiveParams(migratedRequired: boolean, recordSpecs: RecordSpecsModel) {
        let activeRenderMode: RenderModes;
        let activeLifeStatus = recordSpecs.LifeStatusInfo;

        if (recordSpecs.IsNewRecord) {
            activeRenderMode = RenderModes.View;

            return {
                RenderMode: activeRenderMode,
                ActiveLifeStatus: activeLifeStatus
            };
        }

        if (migratedRequired) {
            activeRenderMode = RenderModes.View;
            this._title(NOTIFICATIONS.TITLE_CONVERTED_TYPE_OF_RECORD);
            return {
                RenderMode: activeRenderMode,
                ActiveLifeStatus: activeLifeStatus
            };
        }

        const enabledDisabledStatuses = [LifeStatuses.Enabled.Name.toUpperCase(), LifeStatuses.Disabled.Name.toUpperCase()];


        const validStatus = !!activeLifeStatus.Name
            ? _.find<string>(enabledDisabledStatuses, status => status === activeLifeStatus.Name.toUpperCase())
            : null;
        activeRenderMode = validStatus ? RenderModes.Edit : RenderModes.View;

        return {
            RenderMode: activeRenderMode,
            ActiveLifeStatus: activeLifeStatus
        };
    }

    private GetViewTemplate() {
        return ViewTemplate;
    }

    private GetEditTemplate() {
        return EditTemplate;
    }

    private FireFollowUp(subjectAction: SubjectActionModel) {
        if (subjectAction) {
            this._screen.Trigger('FOLLOWUP_FROM_SUBJECT',
                { followUpRecord: this._followUpRecord, subjectAction: subjectAction });
        }
    }

    private MapToViewModel(lifeStatus: LifeStatusInfo) {
        const viewModel = new LifeStatusViewModel();

        viewModel.Name(lifeStatus.TranslatedName || lifeStatus.Name);
        viewModel.Date(this.FormatDate(lifeStatus.Name && FormatConverter.CorrectTimezone(lifeStatus.LastStatusDate.toString())));
        viewModel.Enabled(lifeStatus.Name && lifeStatus.Name.toUpperCase() === LifeStatuses.Enabled.Name.toUpperCase());
        viewModel.IsCustomStatuses(this.CheckIfStatusIsCustom((lifeStatus.Name)));

        return viewModel;
    }

    private ModifyLifeStatus() {
        this._lifeStatus.Modified = true;

        const lifeStatusName = this._lifeStatus.Enabled() ? LifeStatuses.Enabled.Name : LifeStatuses.Disabled.Name;

        this._lifeStatus.Name(lifeStatusName);
        this._lifeStatus.Date(this.FormatDate(new Date()));
        this._lifeStatus.IsCustomStatuses(this.CheckIfStatusIsCustom(lifeStatusName));
    }

    private FormatDate(date: string | Date) {
        const momentDate = moment(date);
        return date && momentDate.isValid() ? momentDate.format(DATE_FORMATS.FULL_DATETIME.MomentFormat) : 'Date undefined';
    }

    AfterRender(elements: HTMLElement[]) {
        this._el = _.find(elements, (element) => element.nodeType === 1);
        this._El = $(elements).parent()[0];
        
        if (this._flowFolder) {
            const flowFolderIcon = elements[2];

            $(flowFolderIcon).droppable({
                accept: '.recent-block-list-container__flow-folder-popover, .grid-relative-container__flow-folder-popover',
                tolerance: 'touch',
                drop: (event, ui) => {
                    FlowFolderStore.CreateFlowRecord({
                        EntityId: this._entityId,
                        RecordId: this._recordId,
                        ReferenceEntityId: ui.draggable.data('EntityId'),
                        ReferenceRecordId: ui.draggable.data('RecordId')
                    })
                        .then(result => {
                            if (result.Warnings.length > 0) {
                                result.Warnings.forEach(warningMessage => {
                                    new Notifier().Warning(warningMessage);
                                });
                            } else if (!result.IsSuccessfull) {
                                new Notifier().Failed(result.ErrorMessage);
                            } else {
                                new Notifier().Success(NOTIFICATIONS.DATA_SAVED);
                            }
                        })
                        .fail(error => {
                            new Notifier().Failed(error.message);
                        });
                }
            });
        }
    }
}